import Api from './api';
import { getXAPIEnv, getXUserKey } from '@/plugins/account';


export const DomainStatus = {
    OPENED: "OPENED",
    CONFIGURED: "CONFIGURED",
    ERROR: "ERROR"
}

export class Domain {
    url = null;
    status = null;
    expirationDate = null;

    static test(domain) {
        return !/[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(domain);
    }

    static fromObject(obj) {
        const d = new Domain();
        d.url = obj.url;
        d.status = obj.status;
        d.expirationDate = obj.expirationDate;
        return d;
    }
}

export default class DomainAPI {

    static hasError(response) {
        const errors = response.getErrors([]);
        return errors.length > 0 ? errors[0] : false;
    }

    static async list() {
        try {

            //Resposta de sucesso
            // return [{
            //    url: "dominio.com.br",
            //    status: DomainStatus.CONFIGURED,
            //    expirationDate: '2022-12-31'
            // }];

            const response = await Api('store', `domains`, 'get', {}, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() });
            return response.getData([]).map((d) => {
                return Domain.fromObject({
                    url: d.domain,
                    status: d.status,
                    expirationDate: d.expirationDate
                });
            });
        } catch(err) {
            console.error(err);
            return [];
        }
    }

    static async add(domain) {
        //sleep 10s for test
        // await new Promise(resolve => setTimeout(resolve, 10000));

        // Error response example
        // return new Response(null, 500, [
        //   "Ocorreu um erro ao adicionar o domínio!"
        // ]);

        // Success response example
        // return new Response({
        //   domain,
        //   status: 1,
        //   hash: 'AAAAAAAAAAAAAAAA',
        //   expirationDate: '2022-12-31'
        // });

        try {
            const response = await Api('store', `domains`, 'post', { domain }, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() });
            const hasError = DomainAPI.hasError(response);
            if (hasError) {
                throw new Error(hasError);
            }

            const domainResponse = response.getData({});

            return Domain.fromObject({
                url: domainResponse.domain,
                status: domainResponse.status,
                expirationDate: domainResponse.expirationDate
            })

        } catch (err) {
            throw err;
        }
    }

    static async status(domain) {
        try {
            const response = await Api('store', `domains/status/${domain}`, 'get', {}, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() });
            if (DomainAPI.hasError(response)) {
                return null;
            }

            return Domain.fromObject({
                url: d.domain,
                status: d.status,
                expirationDate: d.expirationDate
            })

        } catch (err) {
            console.error(err);
            return null;
        }
    }

    static async delete(domain) {
        try {
            const response = await Api('store', `domains/${domain}`, 'delete', {}, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() });
            const hasError = DomainAPI.hasError(response);
            if (hasError) {
                throw new Error(hasError)
            }
            return response.getData();
        } catch (err) {
            throw err;
        }
    }

    static async exists(domain) {
        try {
            const response = await Api('store', `domains/exists/${domain}`, 'get', {}, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() });
            const hasError = DomainAPI.hasError(response);
            if (hasError) {
                throw new Error(hasError)
            }
            return response.getData({});
        } catch (err) {
            throw err;
        }
    }
}